import React from "react";

interface TexturedCardProps {
  children: React.ReactNode;
  className?: string;
  paddingX?: string;
  paddingY?: string;
  /** Border width in pixels. Set to 0 for borderless. */
  borderSizePx?: number;
  style?: React.CSSProperties;
  contentStyle?: React.CSSProperties;
  /** @deprecated No longer used — kept for backward compatibility */
  rotating?: boolean;
}

export const TexturedCard: React.FC<TexturedCardProps> = ({
  children,
  className = "",
  paddingX = "px-0",
  paddingY = "py-0",
  borderSizePx = 2,
  style,
  contentStyle,
}) => {
  return (
    <div
      className={`cuadra-relative cuadra-bg-background md:cuadra-rounded-lg cuadra-overflow-hidden cuadra-flex cuadra-flex-col ${paddingX} ${paddingY} ${className}`}
      style={{
        border:
          borderSizePx > 0
            ? `${borderSizePx}px solid var(--cuadra-primary)`
            : "none",
        ...style,
        ...contentStyle,
      }}
    >
      {children}
    </div>
  );
};
